<template>
  <div v-if="vehicle && vehicle.motors && vehicle.motors[0]" class="rate">
    <div class="rate__heading">
      {{ vehicle.label }} - {{ vehicle.motors[0].label }}
      <span class="fw-bold">{{ getTranslation(183) }}</span>
    </div>
    <div class="rate__grid">
      <div class="rate__base">
        {{ getTranslation(284) }}
        <span>{{ formatPrice(vehicle.motors[0].price) }} €</span>
      </div>
      <div class="rate__base -white">
        {{ getTranslation(366) }}
        <div class="rate__location" v-html="installment()"></div>
      </div>
    </div>
    <div class="rate__include">
      <div class="mb-3" v-html="getTranslation(187)"></div>
      {{ getTranslation(482) }}
    </div>
    <div class="mt-3 rate__include -grey">
      <p class="fw-normal">{{ getTranslation(286) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { priceManager } from "@/services/price-manager";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "VehicleBasePriceTabComponent",
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
      currency: (store) => store.currency,
    }),
  },
  methods: {
    formatPrice(price) {
      return priceManager.format(price);
    },

    getTranslation(id, params = {}) {
      return getTranslation(id, params);
    },

    installment() {
      if (
        this.vehicle &&
        this.vehicle.motors &&
        this.vehicle.motors[0] &&
        this.vehicle.motors[0].installment
      ) {
        let split = priceManager
          .format(this.vehicle.motors[0].installment)
          .split(",");

        return (
          '<div class="int">' +
          split[0] +
          "</div>" +
          "<div>" +
          '<div class="decimal"><span class="devise">€</span>' +
          (split[1] ? split[1] : "00") +
          "</div>" +
          '<div class="condition">' +
          "/ " +
          this.getTranslation(285).toLowerCase() +
          " " +
          this.getTranslation(287, {
            AMOUNT: this.formatPrice(this.vehicle.motors[0].first_payment),
            CURRENCY: this.currency,
          }) +
          "</div>" +
          "</div>"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rate {
  &__heading {
    text-transform: uppercase;
    font-size: 20px;
    border-bottom: 6px solid $blue;
  }

  &__grid {
    display: flex;
    margin-top: 15px;
  }

  &__base {
    background: $blue;
    color: $white;
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    padding: 15px 30px;
    text-transform: uppercase;
    font-size: 16px;

    &.-white {
      background: $white;
      color: $blue;
    }

    span {
      font-size: 45px;
      font-weight: bold;
      line-height: 1;
      margin-top: 8px;
    }
  }

  &__base + &__base {
    margin-left: 30px;
  }

  &__include {
    background: $white;
    margin-top: 20px;
    padding: 15px 10px;

    &.-grey {
      background: $grey;
    }

    p {
      font-weight: 700;
      margin-bottom: 0;
    }
  }
}
</style>
